import { render, staticRenderFns } from "./SigninIcon.vue?vue&type=template&id=59a4df32&"
import script from "./SigninIcon.vue?vue&type=script&lang=ts&"
export * from "./SigninIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports